import { z } from "zod";
import {
  SIGNED_WEIGHT_KG_MAX,
  SIGNED_WEIGHT_KG_MIN,
  WEIGHT_KG_MAX,
  WEIGHT_KG_MIN,
} from "../units.js";

// The rep and weight bounds of a set, once: dropset steps, LogSet and
// WorkoutSet all parse the same range. The kg bounds themselves live in units.ts.
export const REPS_MAX = 999;
export const Reps = z.number().int().min(0).max(REPS_MAX);
export const WeightKg = z.number().min(WEIGHT_KG_MIN).max(WEIGHT_KG_MAX);
// Bodyweight extra and planner absolute targets allow negative values so
// assisted variants (band-assisted pull-ups, assisted-dip machine) are
// representable without inventing a separate "assistance" type. Range is
// asymmetric: a 500 kg assistance is already absurd, while loaded carries
// can in theory go far above bodyweight.
export const ExtraKg = z.number().min(SIGNED_WEIGHT_KG_MIN).max(SIGNED_WEIGHT_KG_MAX);
